module.exports = __webpack_public_path__ + "img/side-inventory.74c72bc2.svg";